var _path, _polygon, _path2, _rect, _path3, _polygon2, _polygon3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTituloDesigners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 185",
    style: {
      enableBackground: "new 0 0 1080 185"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.6,52.6h-37.3v79.5h36.5c23,0,36.7-14.9,36.7-39.7C173.5,59.5,154,52.6,137.6,52.6z M137.7,122.9h-27.6V61.8h26.5 c18,0,27.1,10.3,27.1,30.6C163.7,112,154.5,122.9,137.7,122.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "197,95.6 370.3,95.6 370.3,86.4 197,86.4 197,61.8 372.4,61.8 372.4,52.6 187.2,52.6 187.2,132.1 373.1,132.1  373.1,122.9 197,122.9 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428.1,88.1l-15.3-3c-14.5-2.9-15.6-6.7-15.6-12.3c0-3.1,0-12.7,21.6-12.7c14.3,0,21.9,5.5,22.5,16.2l0.1,2.3h9.7l-0.1-2.6 c-0.4-11.5-6.5-25.2-33.7-25.2c-22.6,0-30.7,11.3-30.7,21.8c0,14.1,9.4,18.9,24.5,21.9l13.9,2.9c15.9,3.4,17.6,6.7,17.6,12.9 c0,9.1-8,14.1-22.4,14.1c-17.4,0-26-6.4-26.1-19.6l0-2.5h-9.8v2.5c0,13.1,6.3,28.8,36.3,28.8c29.3,0,32.4-16.5,32.4-23.6 C453.1,95.2,441.1,90.7,428.1,88.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 465.1,
    y: 52.6,
    width: 9.8,
    height: 79.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M529.9,99.1h29.7c-2,16-12.8,25.4-29.4,25.4c-22.3,0-32.3-16.2-32.3-32.2c0-18.7,13.6-32.2,32.3-32.2 c14.9,0,25.4,7.1,28.1,18.9l0.4,1.9h9.9l-0.7-3c-3.7-16.9-17.9-27-37.8-27c-27.7,0-42.1,20.8-42.1,41.4c0,24.8,16.9,41.4,42.1,41.4 c12.7,0,23.5-5,30.2-13.6v12h9.2V89.9h-39.7V99.1z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "646.8,116.2 594.7,52.6 585,52.6 585,132.1 594.8,132.1 594.8,68.5 646.9,132.1 656.6,132.1 656.6,52.6 646.8,52.6  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "681.2,95.6 841.9,95.6 841.9,86.4 681.2,86.4 681.2,61.8 844.1,61.8 844.1,52.6 671.4,52.6 671.4,132.1  844.7,132.1 844.7,122.9 681.2,122.9 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M926.8,108.9c-0.1-7.2-3.5-12.9-9.2-15.8c6.5-3.8,10.5-10.4,10.5-18.3c0-22.2-20.8-22.2-27.6-22.2h-40.6v79.5h9.8V98.2h30.7 c14.1,0,16.4,3.4,16.7,14.1c0.4,13.7,0.9,17.3,2.9,19.1l0.7,0.7h9.8l-1.7-3.6C927.5,126.1,927.1,121.9,926.8,108.9z M918.3,74.5 c0,9.9-5.9,14.5-18.7,14.5h-29.9V61.8h31.2C916.5,61.8,918.3,69,918.3,74.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M981.4,88.1l-15.3-3c-14.5-2.9-15.6-6.7-15.6-12.3c0-3.1,0-12.7,21.6-12.7c14.3,0,21.9,5.5,22.5,16.2l0.1,2.3h9.7l-0.1-2.6 c-0.4-11.5-6.5-25.2-33.7-25.2c-22.6,0-30.7,11.3-30.7,21.8c0,14.1,9.4,18.9,24.5,21.9l13.9,2.9c15.9,3.4,17.6,6.7,17.6,12.9 c0,9.1-8,14.1-22.4,14.1c-17.4,0-26-6.4-26.1-19.6l0-2.5h-9.8v2.5c0,13.1,6.3,28.8,36.3,28.8c29.3,0,32.4-16.5,32.4-23.6 C1006.5,95.2,994.5,90.7,981.4,88.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTituloDesigners);
export default __webpack_public_path__ + "static/media/titulo_designers.24071b670d38315aefe513762d9d73eb.svg";
export { ForwardRef as ReactComponent };